module.exports = __webpack_public_path__ + "static/media/CHAP03-OUVERTURE.e4a054a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Skew/img/CHAP03-OUVERTURE.png
// module id = 298
// module chunks = 0